
























































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';
import { Action } from 'vuex-class';
import { EModalSize } from '@getaccept/lib-ui';
import { BrandingHelper } from '@signing-page/helpers/branding.helper';
import { IDocument } from '@signing-page/documents/types/document';
import { EAuthenticationStepType } from '@signing-page/authentication/types/enums/authentication-step-type';
import { IAuthenticationStepInput } from '@signing-page/authentication/types/authentication-step-input';
import LobbyCard from '@signing-page/lobby/components/LobbyCard.vue';
import { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import QnA from '@signing-page/lobby/components/Qna.vue';
import Sms from '@signing-page/lobby/components/Sms.vue';
import IdentifyRecipient from '@signing-page/lobby/components/IdentifyRecipient.vue';
import Consents from '@signing-page/lobby/components/Consents.vue';
import LobbyDocument from '@signing-page/lobby/components/LobbyDocument.vue';
import { IEntity } from '@signing-page/entity/types/entity';
import { ITheme } from '@signing-page/entity/types/theme';
import TopBar from '@signing-page/signing/components/TopBar.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import { actionLoadTokenSuccess } from '@signing-page/session/store/session.actions';
import { namespace as sessionNamespace } from '@signing-page/session/store/session.store';

@Component({
  components: {
    Input,
    Button,
    LobbyCard,
    QnA,
    Sms,
    IdentifyRecipient,
    Consents,
    LobbyDocument,
    TopBar,
  },
  data: () => ({
    EAuthenticationStepType,
    moment,
    EModalSize,
  }),
})
export default class Lobby extends Vue {
  @Prop() consentSteps: IAuthenticationStep[];
  @Prop() nextAuthStep: IAuthenticationStep;
  @Prop() submittingResponse: boolean;
  @Prop() error: boolean;
  @Prop() isCorrectPin?: boolean;
  @Prop() recalled: boolean;
  @Prop() expired: boolean;
  @Prop() rejected: boolean;
  @Prop() gdprDeclined: boolean;
  @Prop() document?: IDocument;
  @Prop() entity?: IEntity;
  @Prop() theme: ITheme;
  @Prop() previewExpired: boolean;
  @Action(actionLoadTokenSuccess, { namespace: sessionNamespace }) setToken: any;

  get showDocument(): boolean {
    return !this.gdprDeclined && ((this.expired && !this.recalled) || this.rejected);
  }

  get showConsents(): boolean {
    return !this.gdprDeclined && this.consentSteps && this.consentSteps.length > 0;
  }

  get showModal(): boolean {
    return !!this.nextAuthStep || this.showConsents;
  }

  get documentLogo(): string {
    return BrandingHelper.getLogoUrl(this.theme);
  }

  handleIdentifyRecipient(answer: IAuthenticationStepInput) {
    this.$emit('identifyRecipient', answer);
  }

  handleQnaAnswer(authAnswer: IAuthenticationStepInput) {
    this.$emit('qnaAnswer', authAnswer);
  }

  handleSendPin() {
    this.$emit('sendPin');
  }

  handleSmsAnswer(authAnswer: IAuthenticationStepInput) {
    this.$emit('smsAnswer', authAnswer);
  }

  handleConsentAnswer(authStepsInput: IAuthenticationStepInput[]) {
    this.$emit('consentAnswer', authStepsInput);
  }

  handleConsentDecline() {
    this.$emit('consentDecline');
  }
}
